import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {IModalDialogHandler} from '../../../services/dialog/dialog.service.interface';
import {UsefulLinksListComponent} from '../../useful-links/parts/useful-links-list/useful-links-list.component';
import {MiniOrbitUsefulLinksListBox} from './boxes/mini-orbit-useful-links-list.box';
import {CyClass} from '../../../../common/cy-classes';

export interface MiniOrbitUsefulLinksListComponentProps {
    dialogHandler: IModalDialogHandler
}

export class MiniOrbitUsefulLinksListComponent extends OrbitComponent<MiniOrbitUsefulLinksListComponentProps> {
    render() {
        return (
            <UsefulLinksListComponent
                onItemClick={() => this.props.dialogHandler.close()}
                linksGroupWrapperBox={MiniOrbitUsefulLinksListBox}
                linksGroupWrapperClassName={CyClass('cy-mini-orbit-useful-links-list')}
            />
        );
    }
}